import ApiClient from './ApiClient';

class InternalArticlesAPI extends ApiClient {
  constructor() {
    super('internal_articles', { accountScoped: true });
  }
}

export default new InternalArticlesAPI();
